export default "__VITE_ASSET__B0F584dz__"